import {FormGroup, Stack, TextInput} from "@unibuddy/patron";
import React from "react";
import {useTranslation} from "@unibuddy/intl";

import {IntlNamespaces} from "../../../../../translations/types";
import {INTL_FIRST_NAME, INTL_LAST_NAME} from "../../../../../translations/settings";

export function NameFormField() {
    const {t} = useTranslation([IntlNamespaces.SETTINGS, IntlNamespaces.ERROR_MESSAGE]);
    return (
        <Stack space="medium">
            <FormGroup
                id="first-name"
                label={t(
                    `${IntlNamespaces.SETTINGS}:${INTL_FIRST_NAME.key}`,
                    INTL_FIRST_NAME.defaultValue,
                )}
            >
                <TextInput name="firstName" autoComplete="given-name" required />
            </FormGroup>
            <FormGroup
                id="last-name"
                label={t(
                    `${IntlNamespaces.SETTINGS}:${INTL_LAST_NAME.key}`,
                    INTL_LAST_NAME.defaultValue,
                )}
            >
                <TextInput name="lastName" autoComplete="family-name" required />
            </FormGroup>
        </Stack>
    );
}
